import LabeledText from './LabeledText';

export default LabeledText;
